import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { displayName, dropdownPlaceholder } from './const';
import { getSubGroupStudentsLabel } from 'legacy-src/utility/utils';
import buildSubgroupStudents from 'chameleon/ui-stack/utilities/utils/buildSubgroupStudents';
import './styles.scss';

const ClassDropdown = ({
  openAssignments,
  sectionName,
  onChange,
  isFinalExam,
  subGroupStudents,
  studentsBySection,
  assignmentId,
  status,
  blackListedStatus,
  isLoading,
  subGroupStudentsLabel,
}) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  const dropdownOptions =
    openAssignments &&
    openAssignments.map((option) => ({
      ...option,
      label: `${option.section_name}${getSubGroupStudentsLabel(
        (option.sub_group_students &&
          option.sub_group_students.length &&
          buildSubgroupStudents(
            option.sub_group_students,
            studentsBySection,
          )) ||
          [],
      )}`,
      value: option.id,
    }));

  const orderedDropdownOptions =
    dropdownOptions &&
    dropdownOptions.sort(
      (a, b) =>
        (a.section_name && a.section_name.localeCompare(b.section_name)) ||
        a.id - b.id,
    );

  const currentAssignment =
    orderedDropdownOptions &&
    orderedDropdownOptions.length &&
    orderedDropdownOptions.find((option) => +option.id === +assignmentId);

  const hasMultipleClasses =
    orderedDropdownOptions && orderedDropdownOptions.length > 1;

  const showDropdown =
    hasMultipleClasses &&
    !isFinalExam &&
    currentAssignment &&
    !blackListedStatus.includes(status);

  if (showDropdown) {
    return (
      <AutocompleteSelect
        className="classes-dropdown"
        options={orderedDropdownOptions}
        value={currentAssignment}
        onChange={onChange}
        disableAutoFocus
        openOnClick
        placeholder={{
          label: dropdownPlaceholder,
        }}
      />
    );
  }

  return (
    <div className="assignment__header--section-name">
      {sectionName}
      {subGroupStudentsLabel ||
        getSubGroupStudentsLabel(
          buildSubgroupStudents(subGroupStudents, studentsBySection),
        )}
    </div>
  );
};

ClassDropdown.displayName = displayName;

ClassDropdown.defaultProps = {
  isFinalExam: false,
};

ClassDropdown.props = {
  openAssignments: PropTypes.array.isRequired,
  sectionName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isFinalExam: PropTypes.bool,
  subGroupStudents: PropTypes.object,
  studentsBySection: PropTypes.object,
  assignmentId: PropTypes.string.isRequired,
  status: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  subGroupStudentsLabel: PropTypes.object,
  blackListedStatus: PropTypes.array.isRequired,
};

export default ClassDropdown;
